"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("regenerator-runtime/runtime");

var _vuejsPaginate = _interopRequireDefault(require("vuejs-paginate"));

var _EbookCard = _interopRequireDefault(require("./EbookCard.vue"));

var _ebookData = _interopRequireDefault(require("./../ebook-data"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var _default = {
  name: "ebooks",
  props: ["data"],
  components: {
    EbookCard: _EbookCard["default"],
    Paginate: _vuejsPaginate["default"]
  },
  data: function data() {
    return {
      loading: true,
      noEBooksText: theme.strings.ebooks.noEBooks,
      ebooks: [],
      page: 1,
      pageCount: 1,
      perPage: 12
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getData().then(function (res) {
      _this.data.ebooks = res;

      _this.$set(_this, "pageCount", Math.ceil(res.length / 12));

      _this.$set(_this, "ebooks", res.slice(0, _this.perPage));

      _this.loading = false;
    })["catch"](function (err) {
      return console.error(err);
    });
  },
  methods: {
    onPaginate: function onPaginate(page) {
      var _this2 = this;

      this.page = page;
      this.$set(this, "ebooks", []);
      setTimeout(function () {
        var ebooks = _this2.data.ebooks.slice((_this2.page - 1) * _this2.perPage, _this2.page * _this2.perPage);

        _this2.$set(_this2, "ebooks", ebooks);

        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }, 0);
    },
    getData: function getData() {
      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _ebookData["default"])().init();

              case 2:
                return _context.abrupt("return", _context.sent);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};
exports["default"] = _default;